<template>
<div class="env-charts-wrapper" v-if="!isShowGroup">
  <div
    v-for="chartData in formatList"
    :key="chartData.factors[0].id"
    class="card"
  >
    <div class="card-header">
      <h3 class="card-title">{{chartData.factors[0].name}}</h3>
    </div>
    <div class="card-body">
      <trend-chart
        :factors="chartData.factors"
        :data-times="chartData.dataTimes"
        :data="chartData.data"
      />
    </div>
  </div>
</div>
<div class="env-charts-wrapper" v-else>
  <div
    v-for="(chartData, index) in formatList"
    :key="index"
    class="card"
  >
    <div class="card-header">
      <h3 class="card-title">
        <span :class="chartData.icon" style="margin-right: 5px;"></span>
        <span>{{chartData.name}}</span>
      </h3>
    </div>
    <div class="card-body">
      <env-group-chart
        :env-factor-map="envFactorMap"
        :data="chartData"
      />
    </div>
  </div>
</div>
</template>

<script>
import unitConverter from '../../../utils/unitConverter'
import TrendChart from './TrendChart'
import EnvGroupChart from './EnvGroupChart'

export default {
  name: 'Charts',
  components: {TrendChart, EnvGroupChart},
  props: {
    isShowGroup: {
      required: true,
      type: Boolean
    },
    envCategoryList: {
      type: Array
    },
    envFactorMap: {
      required: true
    },
    list: {
      required: true,
      type: Array
    },
    columnMap: {
      required: true,
      type: Object
    }
  },
  computed: {
    envCategoryMap () {
      return this.envCategoryList.reduce((map, envCategory) => {
        map[envCategory.id] = {
          ...envCategory,
          childrenFactor: [],
          data: []
        }
        return map
      }, {})
    },
    formatList () {
      let {columnMap} = this

      if (!this.isShowGroup) {
        return Object.values(this.list.reduce((map, data) => {
          let {factorId} = data

          let factor = columnMap[factorId]

          if (factor) {
            let newDataObj = map[factorId]

            if (!newDataObj) {
              newDataObj = map[factorId] = {
                factors: [factor],
                dataTimes: [],
                data: []
              }
            }

            newDataObj.dataTimes.push(data.dataTime)
            newDataObj.data.push({
              [factorId]: {
                value: Number(unitConverter(data.value, factor.stdUnit, factor.stdUnit, factor.molecular).toFixed(1))
              }
            })
          }

          return map
        }, {}))
      }

      let {envCategoryMap} = this
      let newEnvCategoryMap = {...JSON.parse(JSON.stringify(envCategoryMap)), noGroup: {id: 'noGroup', name: '未知分组', childrenFactor: [], data: []}}

      Object.values(columnMap).forEach(factor => {
        if (newEnvCategoryMap[factor.categoryId]) {
          newEnvCategoryMap[factor.categoryId].childrenFactor.push(factor.id)
        }
      })

      let listMap = this.list.reduce((map, el) => {
        if (!map[el.factorId]) {
          map[el.factorId] = {
            id: el.factorId,
            data: []
          }
        }

        map[el.factorId].data.push(el)
        return map
      }, {})

      Object.values(newEnvCategoryMap).forEach(item => {
        item.childrenFactor.forEach(id => {
          if (listMap[id]) {
            newEnvCategoryMap[item.id].data = newEnvCategoryMap[item.id].data.concat(listMap[id].data)
          }
        })
      })

      return Object.values(Object.values(newEnvCategoryMap).reduce((map, el) => {
        map[el.id] = {
          ...el,
          factors: el.childrenFactor.map(item => columnMap[item]),
          data: el.data
        }
        return map
      }, {})).filter(el => el.data.length !== 0)
    }
  }
}
</script>

<style lang="scss" scoped>
.env-charts-wrapper {
  display: flex;
  flex-direction: column;
  gap: 2px;
  height: 100%;
  margin: 0 -0.8em;
  padding: 0 0.8em;
  overflow: auto;
  min-height: 480px;

  > * {
    flex: 1;
    min-height: 350px;
  }

  .card-header {
    display: grid;
    grid-template-columns: auto var(--card-header-height);
    align-items: center;
    padding: 0 10px;
    background: linear-gradient(90deg, #fbc15a 0, #fff);

    > .card-title {
      margin: 0;
      color: #ffffff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/07Env/02History/Charts.vue